export default __webpack_public_path__ + "static/media/water4.a2695e3c.png";